/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * MCQ Status Service
 * @file MCQStatusService.js
 * @author Ujjwal Sana
 */

import Framework, { BaseService } from '@greenville/framework';
import { AET_STORE_EVENTS } from '../common/Constants';

export default class MCQStatusService extends BaseService {
  constructor() {
    super(AET_STORE_EVENTS.MCQ_STATUS_REQUESTED, 'mcqstatusservice');
  }

  /**
   * API call for MCQ status
   * @param {*} eventName
   * @param {*} eventData
   * @returns {Promise}
   */
  handleEvent(eventName, eventData = {}) {
    const { payload } = eventData;

    // PUT request for all MCQs statuses
    return this.getClient('marin').put('/aet/mcq-statuses', payload);
  }

  // eslint-disable-next-line class-methods-use-this
  handleResponse(response) {}
}
